var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefralSession(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 93,
    height: 93,
    viewBox: "0 0 93 93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Higher_Education",
    "data-name": "Higher Education",
    transform: "translate(-455 -169)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9865",
    "data-name": "Path 9865",
    d: "M10,0H83A10,10,0,0,1,93,10V83A10,10,0,0,1,83,93H10A10,10,0,0,1,0,83V10A10,10,0,0,1,10,0Z",
    transform: "translate(455 169)",
    fill: "#fff9e8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1069",
    "data-name": "Group 1069",
    transform: "translate(469.232 195.337) rotate(-13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9940",
    "data-name": "Path 9940",
    d: "M0,0H53.811V53.811H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9941",
    "data-name": "Path 9941",
    d: "M21.484,8.484,17,8.484A4.484,4.484,0,1,0,21.484,4,4.484,4.484,0,0,0,17,8.484",
    transform: "translate(21.116 4.968)",
    fill: "none",
    stroke: "#b28400",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9942",
    "data-name": "Path 9942",
    d: "M21.484,20.484m-4.484,0A4.484,4.484,0,1,0,21.484,16,4.484,4.484,0,0,0,17,20.484",
    transform: "translate(21.116 19.874)",
    fill: "none",
    stroke: "#b28400",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9943",
    "data-name": "Path 9943",
    d: "M7.484,14.484,3,14.484A4.484,4.484,0,1,0,7.484,10,4.484,4.484,0,0,0,3,14.484",
    transform: "translate(3.726 12.421)",
    fill: "none",
    stroke: "#b28400",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9944",
    "data-name": "Path 9944",
    d: "M7,12h6.726l7.847,13.453h7.847",
    transform: "translate(8.695 14.905)",
    fill: "none",
    stroke: "#b28400",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9945",
    "data-name": "Path 9945",
    d: "M25.695,6H17.847L10,19.453",
    transform: "translate(12.421 7.453)",
    fill: "none",
    stroke: "#b28400",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefralSession);
export default __webpack_public_path__ + "static/media/Refral-session.83186cc690c1061ca56de04f04feb77f.svg";
export { ForwardRef as ReactComponent };